// export const backend_url_img = 'http://localhost:5000'

export const backend_url_img = 'https://api.snusconicotine.com'
